import { differenceInMinutes, differenceInHours, differenceInDays, differenceInWeeks } from "date-fns";

export function formatTimeAgo(date: Date | string): string {
  const d = typeof date === "string" ? new Date(date) : date;
  const now = new Date();
  
  const minutes = differenceInMinutes(now, d);
  if (minutes < 1) return "Gerade eben";
  if (minutes < 60) return `Vor ${minutes} Minute${minutes === 1 ? "" : "n"}`;
  
  const hours = differenceInHours(now, d);
  if (hours < 24) return `Vor ${hours} Stunde${hours === 1 ? "" : "n"}`;
  
  const days = differenceInDays(now, d);
  if (days < 7) return `Vor ${days} Tag${days === 1 ? "" : "en"}`;
  
  const weeks = differenceInWeeks(now, d);
  return `Vor ${weeks} Woche${weeks === 1 ? "" : "n"}`;
}
